const tabs = document.querySelectorAll('.filter-tab-label');

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    if (tab.classList.contains('active')) return;
    tabs.forEach(t => t.classList.remove('active'));
    const tab_label = tab.dataset.label;
    const group_data_all = document.querySelectorAll('.custom-filter-desktop .filter-form__group');
    group_data_all.forEach(group_all => {
      group_all.classList.remove('active');
      group_all.classList.add('hidden');
    });
    const group_data = document.querySelector(`.custom-filter-desktop .filter-form__group[data-label="${tab_label}"]`);
    if (group_data) { group_data.classList.remove('hidden'); group_data.classList.add('active');}
    tab.classList.add('active');
  });
});

  (function() {
    // Fix for pagination count error
    function fixPaginationError() {
      const partialElement = document.querySelector('[data-partial]');
      if (partialElement) {
        if (!partialElement.dataset.collectionProductsCount) {
          partialElement.dataset.collectionProductsCount = '{{ collection.products_count }}';
        }
        
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              const newPartial = document.querySelector('[data-partial]');
              if (newPartial && !newPartial.dataset.collectionProductsCount) {
                newPartial.dataset.collectionProductsCount = '{{ collection.products_count }}';
              }
            }
          });
        });
        
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }

    function initializeTabs() {
      document.querySelectorAll('.nav-tab').forEach(tab => {
        tab.addEventListener('click', function() {
          document.querySelectorAll('.nav-tab').forEach(t => t.classList.remove('active'));
          this.classList.add('active');
          const tabName = this.getAttribute('data-tab');
          document.querySelectorAll('.filter-options').forEach(group => {
            const groupName = group.getAttribute('data-filter-group');
            if (groupName === tabName) {
              group.classList.remove('hidden');
            } else {
              group.classList.add('hidden');
            }
          });
        });
      });
    }
    function initializeMobileDrawer() {
      const openBtn = document.getElementById('openFilterBtn');
      const closeBtn = document.getElementById('closeDrawerBtn');
      const drawer = document.getElementById('filterDrawer');
      if (openBtn && closeBtn && drawer) {
        openBtn.addEventListener('click', () => {
          drawer.classList.add('open');
        });
        closeBtn.addEventListener('click', () => {
          drawer.classList.remove('open');
        });
        document.querySelectorAll('.accordion-btn').forEach(btn => {
          btn.setAttribute('aria-expanded', 'false');
          btn.addEventListener('click', function() {
            const panel = document.querySelector(`[data-accordion-panel="${this.getAttribute('data-accordion')}"]`);
            const isOpen = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', !isOpen);
            panel.style.display = isOpen ? 'none' : 'flex';
          });
        });
      }
    }

    function setAnnouncementBarHeightVar() {
      const announcementBar = document.querySelector('.announcement-bar-wrapper');
      if (announcementBar) {
        const height = announcementBar.offsetHeight;
        document.documentElement.style.setProperty('--height-announcement-bar', `${height}px`);
      }
    }

    function watchAnnouncementBarHeight() {
      const announcementBar = document.querySelector('.announcement-bar-wrapper');
      if (announcementBar) {
        setAnnouncementBarHeightVar();
        
        if (window.ResizeObserver) {
          const observer = new ResizeObserver(function(entries) {
            for (let entry of entries) {
              const height = entry.contentRect.height;
              document.documentElement.style.setProperty('--height-announcement-bar', `${height}px`);
            }
          });
          
          observer.observe(announcementBar);
        }
      }
    }

    function initialize() {
      fixPaginationError();
      initializeTabs();
      initializeMobileDrawer();
      setAnnouncementBarHeightVar();
      watchAnnouncementBarHeight();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize);
    } else {
      initialize();
    }
  })();

const elementsToObserve = document.querySelectorAll('.filter-form__group-filter-wrapper');

elementsToObserve.forEach(el => {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'aria-hidden'
      ) {
        // Check the new value of aria-hidden
        const ariaHidden = el.getAttribute('aria-hidden');
        if (ariaHidden === 'false') {
          // Add class 'active' to previous sibling
          const prevSibling = el.previousElementSibling;
          if (prevSibling) {
            prevSibling.classList.add('active');
          }
        } else {
          // Optionally remove class if aria-hidden is true
          const prevSibling = el.previousElementSibling;
          if (prevSibling) {
            prevSibling.classList.remove('active');
          }
        }
      }
    });
  });

  observer.observe(el, { attributes: true });
});


document.addEventListener('click', function(event) {
    if (event.target.classList.contains('filter-form__group-toggle-wrapper') &&
        event.target.classList.contains('active')) {
        
        const nextSibling = event.target.nextElementSibling;
        
        if (nextSibling && nextSibling.classList.contains('filter-form__group-filter-wrapper')) {
            nextSibling.setAttribute('aria-hidden', 'true');
        }
    }
});

